// タブ切替（TIGHTJAPAN / SOREX / サントレックス）
const buttons = document.querySelectorAll(".maker-btn");
const contents = document.querySelectorAll(".maker-content");

buttons.forEach(button => {

  button.addEventListener("click", () => {

    const target = button.dataset.target;

    buttons.forEach(btn => {
      btn.classList.remove("active");
    });

    contents.forEach(content => {
      content.classList.remove("active");
    });

    button.classList.add("active");

    document.getElementById(target)
      .classList.add("active");

  });

});


// 車メーカータブ切替（トヨタ / 日産 / ホンダ など）
document.querySelectorAll('.fitment-tab-btn')
.forEach(button => {

  button.addEventListener('click', function() {

    // 現在のメーカー領域取得
    const makerContent = this.closest('.maker-content');

    // そのメーカー内だけタブボタン切替
    makerContent.querySelectorAll('.fitment-tab-btn')
      .forEach(btn => btn.classList.remove('active'));

    this.classList.add('active');

    // そのメーカー内だけコンテンツ切替
    makerContent.querySelectorAll('.fitment-content')
      .forEach(content => content.classList.remove('active'));

    makerContent.querySelector('#' + this.dataset.tab)
      .classList.add('active');

  });

});


// ========================
// 全メーカー横断検索
// ========================
document.getElementById('fitmentSearch')
.addEventListener('keyup', function() {

  const keyword = this.value.toLowerCase();

  // ========================
  // 検索文字なし
  // ========================
  if(keyword === ''){

    document.body.classList.remove('search-mode');

    // 全行表示
    document.querySelectorAll('tbody tr')
      .forEach(row => row.classList.remove('hidden-row'));

    // メーカー閉じる
    document.querySelectorAll('.maker-content')
      .forEach(content => content.classList.remove('active'));

    // 車メーカータブ閉じる
    document.querySelectorAll('.fitment-content')
      .forEach(content => content.classList.remove('active'));

    // タブボタンOFF
    document.querySelectorAll('.fitment-tab-btn')
      .forEach(btn => btn.classList.remove('active'));

    // メーカーボタンOFF
    document.querySelectorAll('.maker-btn')
      .forEach(btn => btn.classList.remove('active'));

    // 初期表示（TIGHTJAPAN）
    document.getElementById('tightjapan')
      .classList.add('active');

    document.querySelector('.maker-btn[data-target="tightjapan"]')
      .classList.add('active');

    // 初期表示（トヨタ）
    document.getElementById('tight-toyota')
      .classList.add('active');

    document.querySelector('[data-tab="tight-toyota"]')
      .classList.add('active');

    return;

  }

  // ========================
  // 検索時
  // ========================

  document.body.classList.add('search-mode');

  // 一旦全部閉じる
  document.querySelectorAll('.maker-content')
    .forEach(content => content.classList.remove('active'));

  document.querySelectorAll('.fitment-content')
    .forEach(content => content.classList.remove('active'));

  document.querySelectorAll('.maker-btn')
    .forEach(btn => btn.classList.remove('active'));

  document.querySelectorAll('.fitment-tab-btn')
    .forEach(btn => btn.classList.remove('active'));


  // 各テーブル検索
  document.querySelectorAll('.fitment-content')
  .forEach(content => {

    let hasMatch = false;

    let lastRowspanText = '';

    const rows = content.querySelectorAll('tbody tr');

    // 一旦全部隠す
    rows.forEach(row => {
      row.classList.add('hidden-row');
    });

    for(let i = 0; i < rows.length; i++) {

      const row = rows[i];

      const cells = row.querySelectorAll('td');

      // 行テキスト
      let rowText = row.innerText.toLowerCase();

      // rowspan継承
      if(cells.length >= 3){

        const thirdCell = cells[2];

        if(thirdCell.hasAttribute('rowspan')){

          lastRowspanText =
            thirdCell.innerText.toLowerCase();

        }

      }

      // rowspan継承テキスト追加
      rowText += ' ' + lastRowspanText;

      // 検索判定
      const matched = rowText.includes(keyword);

      if(matched){

        hasMatch = true;

        // 自分表示
        row.classList.remove('hidden-row');

        // rowspan取得
        let rowspan = 1;

        row.querySelectorAll('td').forEach(td => {

          if(td.hasAttribute('rowspan')){

            rowspan = Math.max(
              rowspan,
              parseInt(td.getAttribute('rowspan'))
            );

          }

        });

        // rowspan分の子行も表示
        for(let j = 1; j < rowspan; j++){

          if(rows[i + j]){

            rows[i + j]
              .classList.remove('hidden-row');

          }

        }

      }

    }

    // 該当あり
    if(hasMatch){

      // 車メーカー表示
      content.classList.add('active');

      // 親メーカー表示
      const makerContent =
        content.closest('.maker-content');

      makerContent.classList.add('active');

      // メーカーボタンON
      const makerId = makerContent.id;

      document.querySelector(
        '.maker-btn[data-target="' + makerId + '"]'
      )?.classList.add('active');

    }

  });

});